export default {
  'permissionManagement.title': '权限管理',
  'permissionManagement.restaurantList': '餐厅列表',
  'permissionManagement.rolesAndPermissions': '角色及权限',
  'permissionManagement.roles': '角色',
  'permissionManagement.permissions': '权限',
  'permissionManagement.assign.title': '分配权限',
  'permissionManagement.assign.permission': '权限',
  'permissionManagement.assign.restaurants': '餐厅',
  'permissionManagement.assign.permission.required': '请选择权限',
  'permissionManagement.assign.restaurants.required': '请选择餐厅',

  'permissionManagement.action.assignPermissionForOwners': '为餐厅老板分配权限',
  'permissionManagement.action.assign': '分配',
  'permissionManagement.action.selectAll': '全选',
};
